const removeInvalidInlineStyles = (inlineStyleRanges) => {
  if (!inlineStyleRanges) {
    return inlineStyleRanges;
  }
  return inlineStyleRanges.filter(({ style }) => {
    return !(typeof style === "number" || typeof style === "string" && !Number.isNaN(Number(style)));
  });
};

export { removeInvalidInlineStyles };
//# sourceMappingURL=removeInvalidInlineStyles.js.map
